
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { HelpService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private typeList: any[] = []
    private list: any[] = []
    private form = {
        typeId: '',
        id: ''
    }
    private loading = false
    private isLoading = true
    private firstInit = true
    private rules = {
        id: [{ required: true, message: '请选择文章', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择分类', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    async mounted() {
        await this.getTypeList()
        await this.getArticles()
        if (this.firstInit) {
            this.isLoading = false
        }
        this.firstInit = false
    }

    async getTypeList() {
        this.isLoading = true
        const result = await HelpService.getArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
        }
        this.isLoading = false
    }

    async getArticles() {
        const params = { type_id: this.form.typeId ? this.form.typeId : undefined }
        this.isLoading = true
        const result = await HelpService.getArticles(params)
        if (result.status === 200) {
            this.list = result.data.list
        }
        if (!this.firstInit) {
            this.isLoading = false
        }
    }

    onTypeChange() {
        this.getArticles()
    }

    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                this.loading = true
                const params = {
                    type_id: this.form.typeId,
                    id: this.form.id,
                    recommend: 1
                }
                const result = await HelpService.updateArticle(params)
                if (result.status === 200) {
                    this.$msuccess('添加成功!')
                }
                this.loading = false
            }
        })
    }

    onReset() {
        this.formRef.resetFields()
    }
}
